//@ts-nocheck
import { Editor, Transforms, Path } from 'slate'
import isHotkey from 'is-hotkey'

export const customCodeBlockKeydown = (event, editor) => {
if(event.key === 'Enter' && !event.shiftKey){
    event.preventDefault()
    const [code] = Editor.nodes(editor, {
        match: (n: any) => n.type === 'code'
      })
      if (!code) {
        editor.insertBreak()
        return
      }
  
  editor.insertText('\n')
}

}

export const handleExitCodeBlock = (event, editor) => {
  const { selection } = editor

  if (!selection) return
  if (!isHotkey('shift+enter', event)) return

  event.preventDefault()
  event.stopPropagation()
  
  const [code] = Editor.nodes(editor, {
    match: (n: any) => n.type === 'code'
  })
  if (!code) return
  
  if(code){
  const text = code[0].children[0].text.replace(/[\s\n]+$/, '')
  Transforms.setNodes(
    editor,
    { children: [{ text }] },
    { at: code[1] }
  )

  // Insert new paragraph after the code block
  const nextPath = Path.next(code[1])
  const newNode = { type: 'p', children: [{ text: '' }] }
  Transforms.insertNodes(editor, newNode, { at: nextPath, select: true })
}
}

